<template>
  <div class="wrapper">
    <div class="container">
      <h3>Search Near by Offers</h3>
      <!-- <p>Expolore top rated tours, hotels and restaurants around the world</p> -->
      <form id="filter-type-1" @submit.prevent="">
        <div class="row no-gutters custom-search-input-2">
          <div class="col-lg-4">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                placeholder="pincode..."
                v-model="search.pincode"
              />
            </div>
          </div>
          <div class="col-lg-2">
              <label>-OR-</label>

          </div>
          <div class="col-lg-4">
            <div class="form-group text-black">
              <vue-simple-suggest   
                v-model="search.location"
                display-attribute="name"
                value-attribute="url"
                :list="getSuggestionList"
                @select="getvalue($event)"
              ></vue-simple-suggest>

              <br />
              <i class="icon_pin_alt" @click="currentLoc()"></i>
            </div>
          </div>
          <div class="col-lg-2 s text-black" >
                      {{search.range+ "Km"}}

         <input type="range" class="form-range " list="tickmarks" min="0" max="20" v-model="search.range" />

          </div>
        </div>
        <div class="row no-gutters custom-search-input-2">
          <div class="col-lg-5">
            <select2-multiple-control
              v-model="search.categories"
              :options="catOptions"
              :settings="{
                multiple: true,
              }"
              multiple
              @select="catSelectEvent($event)"
            />
          </div>
          <div class="col-lg-5">
            <select2-multiple-control
              v-model="search.subcategories"
              :options="subCatOptions"
              :settings="{ multiple: true }"
              @select="subcatselectEvent($event)"
              placeholder="-Select Categories-"
            />
          </div>
          <div class="col-lg-2">
            <input
              type="button"
              class="btn_search"
              value="Search"
              @click.prevent="() => loadNearbyOffers()"
            />
          </div>
         
        </div>
        
        <!-- /row -->
      </form>
    </div>
  </div>
</template>
<script>
import API from "../services/index";
import { EventBus } from "@/EventBus.js";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
export default {
  props: ["loadNearbyOffers", "search"],
  data() {
    return {
      catOptions: [],
      subCatOptions: [],
    };
  },
  components: {
    VueSimpleSuggest,
  },
  beforeMount() {
    //console.log("search from home: " + this.search);
    this.getParentCategories();
  },
  methods: {
    emitFilterRequest() {
      //alert("hiii");
      EventBus.$emit("emittedData", {
        catList: this.catOptions,
        subCatList: this.subCatOptions,
        search: this.search,
      });
    },
    getSuggestionList () {
      var i =[]
      var config = {
    headers: {
    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
}
}
      if (this.search.location.length >= 2) {
       return API.get(`https://location.securebrandtech.com/auto/api?q=${this.search.location}`,config)
          .then(function (response) {
        response.data.features.forEach(function (feature) {
            i.push(`${feature.properties.name} ${feature.properties.state} ${feature.properties.country} ${feature.properties.postcode?feature.properties.postcode:feature.properties.countrycode}`) 
            })
            var uniq = [ ...new Set(i) ];
            return uniq 
            
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
     currentLoc() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition)
      } else {
        this.error = 'Geolocation is not supported.'
      }
    },
   showPosition(position){
  position.coords.latitude
  position.coords.longitude
  var location = [position.coords.latitude,position.coords.longitude]
  this.SuggestionList(location)
      
   }, 
   SuggestionList(location){
      var i = [];
      // if (this.search.location.length >= 2) {
         API.get(`https://location.securebrandtech.com/auto/api?q=india&lat=${location[0]}&lon=${location[1]}`
        )
          .then( (response)=> {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county?feature.properties.county:"" +
                  " " +
                  " " +
                  feature.properties.state?feature.properties.state:"" +
                  " " +
                  feature.properties.postcode?feature.properties.postcode:""
              );
            });
            var uniq = [...new Set(i)];
            this.search.location = uniq[1]        
          })

          .catch(function (error) {
            console.log(error);
          });
 },
    getParentCategories() {
      API.get("categories/parent_services_select2list")
        //.get("categories/parent_services")
        .then((res) => {
          this.catOptions = res.data.data;
          this.emitFilterRequest();
          this.search = this.search.categories;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    setSubCategory(categoryId, mode) {
      //alert(categoryId);
      let selSubCat = this.search.subcategories;
      API.get(
        "categories/parent_services_select2list/" + window.btoa(categoryId)
      )
        //.get("categories/parent_services")
        .then((res) => {
          if (mode == "push") {
            res.data.data.forEach((val) => {
              console.log("val=" + JSON.stringify(val));
              this.subCatOptions.push(val);
              //this.subCatOptions.concat(res.data.data);
            });

            //console.log("sub cat options=" + this.subCatOptions);
          } else {
            //this.search.subcategories.push(res.data.data);
            res.data.data.forEach((val) => {
              this.subCatOptions.splice(this.subCatOptions.indexOf(val.id), 1);
            });
          }

          this.search.subcategories = selSubCat;
          this.emitFilterRequest();
          //this.loadNearbyOffers(this.search);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    catSelectEvent(e) {
      var sel = e.selected;
      if (sel) {
        this.setSubCategory(e.id, "push");
        this.search.categories.push(e.id);
      } else {
        this.setSubCategory(e.id, "remove");
        this.search.categories.splice(this.search.categories.indexOf(e.id), 1);
      }
      //this.loadNearbyOffers(this.search);
      this.emitFilterRequest();
    },
    subcatselectEvent(e) {
      var sel = e.selected;
      //alert(sel + " " + e.id + " " + e.text + " " + e.selected);
      if (sel) {
        this.search.subcategories.push(e.id);
      } else {
        this.search.subcategories.splice(
          this.search.subcategories.indexOf(e.id),
          1
        );
      }
      //this.loadNearbyOffers(this.search);
    },
    getvalue(value){
      // var i = [];
      API.get(`https://location.securebrandtech.com/auto/api?q=${value}`)
        .then( (response)=> {
         var j =0 ;
          response.data.features.forEach( (feature)=> {
            if(j === 0){
               this.search.geocodes = feature.geometry.coordinates
            // i= feature.geometry.coordinates;
            }
           j++;
          });
        })
        .catch(function (error) {
          console.log(error);
        });  
        
    }
  },
};
</script>
<style scoped>
.vue-simple-suggest.designed.focus{
color: black;
border: 1px solid;
}
.s{
color: black;
}
</style>
